import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const AuthorStore = create((set) => ({
    authors: null,
    author: null,
    fileForUpload: null,
    availableImages: null,
    currentPage: 1,
    pageSize: 9,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.author[attributeName] = newValue;
            return { author: state.author };
        });
    },

    resetAuthor: () => {
        set((state) => {
            return { author: {} };
        });
    },

    loadAll: (pageSize, currentPage, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'author/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    authors: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    loadAllForSelectList: (successCallback, errorCallback) => {
        const payload = { shouldLoadAll: true };
        const url = AppConfig.HOST_URL + 'author/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    authors: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'author/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ author: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = data;
        var url = AppConfig.HOST_URL + 'author/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    save: (data, successCallback, errorCallback) => {
        const payload = data;
        var url = AppConfig.HOST_URL + 'author/save';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (authorId, successCallback, errorCallback) => {
        const payload = {
            id: authorId,
        };

        var url = AppConfig.HOST_URL + 'author/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    listAvailableImages: (authorId, successCallback, errorCallback) => {
        const payload = { authorId: authorId };
        var url = AppConfig.HOST_URL + 'fileUpload/loadAllImages';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => {
                    return { availableImages: data };
                });
            },
            successCallback,
            errorCallback,
        );
    },

    uploadFile: (id, file, fileType, successCallback, errorCallback) => {
        var formData = new FormData();
        formData.set('file', file);
        formData.set('fileType', fileType);
        formData.set('authorId', id.toString());

        const url = AppConfig.HOST_URL + 'fileUpload/uploadFile';

        return BackEndConnection.doAxiosFormDataPost(
            url,
            formData,
            () => {
                set((state) => {
                    return { fileForUpload: null };
                });

                if ('image' == fileType) {
                    set((state) => {
                        state.listAvailableImages(
                            id,
                            true,
                            () => {},
                            () => {},
                        );
                        return {}; // No state update here
                    });
                }
            },
            successCallback,
            errorCallback,
        );
    },

    deleteFile: (authorId, filename, successCallback, errorCallback) => {
        const payload = {
            authorId: authorId,
            filename: filename,
        };
        const url = AppConfig.HOST_URL + 'fileUpload/deleteFile';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                set((state) => {
                    state.listAvailableImages(
                        authorId,
                        true,
                        () => {},
                        () => {},
                    );
                    return {}; // No state update here
                });
            },
            successCallback,
            errorCallback,
        );
    },

    setFileForUpload: (file) => {
        set((state) => {
            return { fileForUpload: file };
        });
    },
}));

export default AuthorStore;
